import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { ModelCategory } from '../../../types/faq/faq_model'
import CategoriesCard from './CategoriesCard'
import { useMediaQuery } from 'react-responsive'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			questionsContainerStyle: {
				'& h1.questions_title': {
					margin: 0
				}
			},
			questionsContainerLargeScreenStyle: {
				marginTop: 40,

				'& p.questions_text': {
					margin: '26px 0 40px'
				}
			},
			questionsContainerSmallScreenStyle: {
				marginTop: 35,

				'& p.questions_text': {
					margin: '20px 0 24px'
				}
			}
		}
	)
)

interface AcceptingProps {
	categories: ModelCategory[]
}

type QuestionsProps = AcceptingProps

const Questions: React.FC<QuestionsProps> = (
	{
		categories
	}
) => {
	const classes = useStyle()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const questionsContainerClass: ClassValue = classNames(
		classes.questionsContainerStyle,
		isLargeScreen ? classes.questionsContainerLargeScreenStyle : classes.questionsContainerSmallScreenStyle
	)

	const titleClass: ClassValue = classNames(
		'questions_title',
		classes.colorBlue,
		isLargeScreen ? classes.title2 : classes.title6
	)

	const textClass: ClassValue = classNames(
		'questions_text',
		classes.colorBlue,
		isLargeScreen ? classes.text1_opacity : classes.text3_opacity
	)

	const cardContainer: ClassValue = classNames(
		'row',
		isLargeScreen ? classes.flexBetween : classes.flexColumn
	)

	return (
		<div className="col-xs-12">
			<div className={questionsContainerClass}>
				<h1 className={titleClass}>
					<FormattedMessage
						id="requests.frequentQuestions"
						defaultMessage="Les questions fréquentes"
						description="Title subpage"
					/>
				</h1>

				<p className={textClass}>
					<FormattedMessage
						id="requests.havingQuestions"
						defaultMessage="Vous avez uen question ?"
						description="Text subpage"
						values={
							{
								br: <br />
							}
						}
					/>
				</p>

				<div className={cardContainer}>
					{
						categories.map(
							(category) => (
								<CategoriesCard
									key={category.name}
									category={category}
								/>
							)
						)
					}
				</div>
			</div>
		</div>
	)
}

export default Questions
